import React, { useState, useEffect, Fragment } from "react";
import TableCourses from "./TableCourses";
import {
  Grid,
  TableContainer,
  Container,
  TableRow,
  TableCell,
  Table,
  TableHead,
  TableBody,
  Box,
  Zoom,
} from "@material-ui/core";
import MethodGet from "../../Config/Services";
import AppBar from "@material-ui/core/AppBar";
import { makeStyles } from "@material-ui/core/styles";
import Swal from "sweetalert2";
import Typography from "@material-ui/core/Typography";
import Fab from "@material-ui/core/Fab";
import AddIcon from "@material-ui/icons/Add";
import { green } from "@material-ui/core/colors";
import { Button, Tooltip } from "@material-ui/core";
import Moment from "moment";
import DoneIcon from "@material-ui/icons/Done";

import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { toast } from "react-toastify";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
  btnPlus: {
    display: "absolute",
    marginTop: "-42%",
    marginLeft: "-35%",
    //zIndex:2,
    position: "relative",
  },
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[600],
    },
  },
  TableRow: {
    background: "Orange",
  },
  container: {
    paddingBottom: theme.spacing(4),
    paddingInlineEnd: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingLeft: theme.spacing(15),
  },
  typography: {
    paddingTop: theme.spacing(4),
    margin: theme.spacing(1),
    paddingLeft: theme.spacing(30),
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(9),
    paddingRight: theme.spacing(2),
    marginBlockEnd: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    "&:hover": {
      //you want this to be the same as the backgroundColor above
      backgroundColor: "#3f51b5",
    },
    color: "inherit",
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 615,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paperModal: {
    position: "absolute",
    width: 500,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  iconButton: {
    "& > svg": {
      margin: theme.spacing(2),
    },
  },
  TblHeader: {
    backgroundColor: "indigo",
    color: "white",
    fontSize: "11pt",
    fontFamily: "arial",
  },
  fabGreen: {
    color: theme.palette.common.white,
    backgroundColor: "#4caf50",
    "&:hover": {
      backgroundColor: "#2d8631",
    },
  },
  fabBlueExtend: {
    color: theme.palette.common.white,
    backgroundColor: "indigo",
    "&:hover": {
      backgroundColor: "#4b0082d4",
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
const defaultState = {
  start_time: "07:30",
  date_init: Moment().format("YYYY-MM-DD"),
  date_end: Moment().format("YYYY-MM-DD"),
  classroom_id: "",
  end_time: "08:30",
};

function Row({
  key,
  capacity,
  onChange,
  onRemove,
  start_time,
  date_init,
  date_end,
  classroom_id,
  end_time,
  SchoolStorageID,
}) {
  return (
    <TableCourses
      end_time={end_time}
      date_init={date_init}
      date_end={date_end}
      onChange={onChange}
      key={key}
      onRemove={onRemove}
      SchoolStorageID={SchoolStorageID}
      start_time={start_time}
      classroom_id={classroom_id}
      capacity={capacity}
    />
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const IndividualCoursesList = (props) => {
  const { courses, saveCourses, SchoolStorageID, saveDisableButton, capacity } =
    props;

  const [value, setValue] = React.useState(0);

  const [end, setEnd] = React.useState(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [rows, setRows] = useState([defaultState]);

  const handleOnChange = (index, name, value) => {
    const copyRows = [...rows];
    copyRows[index] = {
      ...copyRows[index],
      [name]: value,
    };
    setRows(copyRows);
  };

  const handleOnRemove = (index) => {
    const copyRows = [...rows];
    copyRows.splice(index, 1);
    if (copyRows.length == 0) {
      Swal.fire({
        title: "Error",
        text: "Debes registrar al menos una clase",
        icon: "warning",
      });
      return;
    } else {
      setRows(copyRows);
    }
  };

  const handleOnAdd = (index) => {
    setRows(rows.concat(defaultState));
  };

  const handleOnEnd = (index) => {
    //saveCourses(courses);
    let i = 0;

    for (i = 0; i < rows.length; i++) {
      if (rows[i].classroom_id == "") {
        Swal.fire({
          title: "Error",
          text: "Aún no has seleccionado un salón para la clase " + (i + 1),
          icon: "warning",
        });
        return;
      }
      if (rows[i].date_init > rows[i].date_end) {
        Swal.fire({
          title: "Error",
          text:
            "La fecha inicio debe ser menor a la fecha final en la clase " +
            (i + 1),
          icon: "warning",
        });
        return;
      }
      if (rows[i].start_time >= rows[i].end_time) {
        Swal.fire({
          title: "Error",
          text:
            "La hora inicio debe ser menor a la hora final en la clase " +
            (i + 1),
          icon: "warning",
        });
        return;
      }
    }

    for (i = 0; i < rows.length; i++) {
      courses[index].info.push(rows[i]);
    }

    setValue(value + 1);

    if (value + 1 >= courses.length) {
      saveDisableButton(false);
      setEnd(false);
    }
    //console.log(courses[index]);
    toast.success(
      <div>
        <DoneIcon />
        El modulo {courses[index].name} ha sido programado exitosamente
      </div>,
      {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }
    );
    //console.log(courses);
  };

  //console.log(rows,'columans');

  const classes = useStyles();


  return (
    <div className={classes.root}>
    <AppBar position="static" color="default">
      <Tabs
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable auto tabs example"
      >
        {courses.map((course, index) => (
          <Tab label={course.name} {...a11yProps(index, setRows)} disabled />
        ))}
        <Tab
          label="Terminar"
          {...a11yProps((courses.length + 1), setRows)} disabled
        />
      </Tabs>
    </AppBar>
    {courses.map((course, index) => (
      <TabPanel value={value} index={index}>
        <Grid item xs={12}>
          <Grid item xs={2} xl={2} style={{ position: "absolute" }}>
            <Zoom in={value === index} timeout={650} unmountOnExit>
              <Grid item xs={2} xl={2} className={classes.btnPlus}>
                <Typography component="h1" variant="h4" align="center">
                  <Box align="right">
                    <Fab
                      className={classes.fabGreen}
                      aria-label="add"
                      size="medium"
                      onClick={() => handleOnAdd(index)}
                    >
                      <Tooltip
                        title="Agregar Programacion"
                        aria-label="Agregar Programacion"
                      >
                        <AddIcon size="large" />
                      </Tooltip>
                    </Fab>
                  </Box>
                </Typography>
              </Grid>
            </Zoom>
          </Grid>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow className={classes.TableRow}>
                  <TableCell className={classes.TblHeader} align="center">
                    Clase
                  </TableCell>
                  <TableCell className={classes.TblHeader} align="center">
                    Fecha Inicio
                  </TableCell>
                  <TableCell className={classes.TblHeader} align="center">
                    Fecha Término
                  </TableCell>
                  <TableCell className={classes.TblHeader} align="center">
                    Hora De Inicio
                  </TableCell>
                  <TableCell className={classes.TblHeader} align="center">
                    Hora De Término
                  </TableCell>
                  <TableCell className={classes.TblHeader} align="center">
                    Salón
                  </TableCell>
                  <TableCell className={classes.TblHeader} align="center">
                    Eliminar
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {end ? (
                  <TableRow>
                    <TableCell align="center" colSpan={6}>
                      Clases Programadas, Para Terminar El Registro Da Click
                      En Guardar Diplomado
                    </TableCell>
                  </TableRow>
                ) : (
                  rows.map((row, key) => (
                    <Row
                      {...row}
                      onChange={(name, value) =>
                        handleOnChange(key, name, value)
                      }
                      onRemove={() => handleOnRemove(key)}
                      SchoolStorageID={SchoolStorageID}
                      key={key}
                      capacity={capacity}
                    />
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12} xl={12} style={{ marginBottom: -20 }}>
          <Grid item xs={2} xl={2}>
            <Zoom in={value === index} timeout={425} unmountOnExit>
              <Grid item xs={2} xl={2}>
                <Typography component="h1" variant="h4" align="center">
                  <Box align="center">
                    <Fab
                      className={classes.fabBlueExtend}
                      aria-label="add"
                      size="medium"
                      onClick={() => handleOnEnd(index)}
                      variant="extended"
                    >
                      <DoneIcon size="large" />
                      <b> CONTINUAR</b>
                    </Fab>
                  </Box>
                </Typography>
              </Grid>
            </Zoom>
          </Grid>
        </Grid>
      </TabPanel>
    ))}
    {end && (
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow className={classes.TableRow}>
              <TableCell className={classes.TblHeader} align="center">
                Fecha Inicio
              </TableCell>
              <TableCell className={classes.TblHeader} align="center">
                Fecha Término
              </TableCell>
              <TableCell className={classes.TblHeader} align="center">
                Hora De Inicio
              </TableCell>
              <TableCell className={classes.TblHeader} align="center">
                Hora De Término
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {end && (
              rows.map((row, key) => (
                <TableRow>
                  <TableCell align="center">{row.date_init}</TableCell>
                  <TableCell align="center">{row.date_end}</TableCell>
                  <TableCell align="center">{row.start_time}</TableCell>
                  <TableCell align="center">{row.end_time}</TableCell>
                </TableRow>
              ))
            )
            }
          </TableBody>
        </Table>
      </TableContainer>
    )}
  </div>
  );
};

export default IndividualCoursesList;
